module.exports = __webpack_public_path__ + "static/media/abdata_logo.f7bfe9c1.png";